module.exports = {
    LoginCode: 1001, //登录
    RegisterCode: 1002, //用户注册
    UserInfo: 3, //查询用户信息
    ModifyPassCode: 8, //修改密码
    SMS: 1011, //短信验证码
    PublishCode: 17,//赛事发布
    PublishUpdateCode: 18,//赛事发布修改
    SystemCode: 1004,//系统数据
    PublishQuery: 1029,//赛事查询
    UserInfoSearch:1026,//模糊查询
    
    HomePublicRank: 1103,//首页排行榜
    ApplyCode: 24, // 选手报名  
    ApplyGuest: 1040, //游客报名
    Authentification:4,  // 信息认证
    UserInfoUpdate: 5, //修改个人信息
    AuthQuery: 6,//获取认证信息
    AuthUpdate: 7,//修改认证信息
    AdminCode: 9, //查询所有认证信息
    AdminAudit: 10, //信息认证审核
    ApplyClub: 11, //入会申请
    HostAddOrUpdate: 19,//新增和修改主办方
    HostQuery: 1030,//查询主办方
    UnderTakeAddOrUpdate: 20,//新增和修改承办方
    UnderTakeQuery: 1031,//查询承办方
    SponsorAddOrUpdate: 21,//新增和修改冠名方
    SponsorQuery: 1032,//查询冠名方
    OrganizerAddOrUpdate: 22,//新增和修改协办方
    OrganizerQuery: 1033,//查询协办方
    RefereeAddOrUpdate: 23,//新增和修改裁判
    RefereeQuery: 1034,//查询裁判      
    SearchValue: 1026, //模糊查询
    UserAssociation: 1027, //查询账号所在协会
    MemberAssociation: 13, //查询会员所在协会
    AssociationMember: 14, //查询协会下辖会员
    AssociationAudit: 15,//协会审核入会
    AssociationUpdate: 16,//协会修改会员信息
    PlayerCode: 1035,//选手查询
    UploadPic: 1022, //图片上传
    PubSettingCode: 25,//赛事设置
    PubSettingQuery: 26,//赛事设置查询
    PubArrange: 29, //赛事编排对阵查询
    PubArrangeSet: 30, //赛事编排对阵设置
    PubEncounter: 31, //对阵赛事选手查询
    PubRemove: 32,//删除选手
    PubWaive: 33,//赛事选手参赛弃权
    PubUpdateName: 40,//赛事选手名称修改
    PubDeskSet: 27, //赛事裁判桌号设置
    PubDeskQuery: 28, //赛事裁判桌号查询
    // 签到页面用到的接口
    SignIn: 1036,//赛事选手签到
    SignQuery: 1046,//签到查询
    ScoreSub: 1037,//选手 - 本局赛事成绩提交
    GradeQuery: 1038,//选手-赛事成绩查询    
    ScoreConfirm: 1039,//本轮赛事成绩确认 
    ScoreOver: 34,//本局赛事成绩提交   
    // 分数设置 成绩查询
    ScoreQuery:35, // 赛事成绩查询
    ScoreRoundConfirm: 36,//本轮赛事成绩确认
    PubComplete: 37,//本轮赛事完成
    RankQuery: 38,//赛事排名查看
    SaveRank: 39,//赛事排名保存
   
    // 管理其它    
    RankScore: 1041,//赛事排名-成绩
    RankScorePartner: 1042,//赛事排名-成绩（选手每轮对手或搭档成绩）
    RankScoreDetail: 1043, //赛事成绩详细
    PubManageQuery: 1044, //赛事管理查询
    PlayerRank: 1045, //选手赛事名次查询
    // 重新生成编号
    SetPlayerId: 41,// 重新生成编号
    // 添加修改删除新闻
    AddUpdateNews: 42,
    // 查询新闻
    NewsQuery: 1047,
    // 发布广告位
    PubAdvert: 43,
    //用于网站首页赛事栏查询和小程序
    PublishQueryPublic: 1101,

    MemberRank: 44,// 会员信息列表
    MemberScoreSet:45,//会员设置积分
    MemberAudit: 46,//会员等级确认
    RankRoundQuery: 47, //赛事排名查看-第几轮47
    PubGradeCode: 1051,//赛事评定纬度
    // 排行榜
    HomeRank: 52,
    FinishConfirmScore: 51, //赛事完成积分确认
    // 培训相关接口
    TrainAdd: 54,//新增培训
    TrainQuery: 55,// 培训查询
    TrainUpdate: 59, //修改培训
    TrainDesSetting: 56, //培训详情设置
    TrainDesUpdate: 60,//培训详情设置修改
    TrainUnderTake: 57, //培训协办单位设置
    TrainerSetting: 58, //培训讲师设置
    TrainQueryHome: 1053,//培训查询首页
    TrainDetailQuery: 1054,//培训详情查询、首页培训列表查询
    TrainOrganizer: 1055, //培训协办查询
    TrainOrganizerAddOrUpdate:57,//培训协办设置
    TeacherQuery: 1056,//培训讲师查询
    TeacherAddOrUpdate: 58,//培训讲师设置
    // 培训报名签到相关接口
    TeacherTrainQuery: 61,// 讲师查询自己参加培训
    TeacherSetting: 62, // 讲师设置培训开始或结束
    TrainSignQuery: 63, // 培训签到查询
    TrainSignSet:64, //培训签到设置
    TrainApply: 65, // 策划师培训学员报名
    TrainJoinUserQuery: 66,  // 学员查询参加培训
    TrainSign: 67, // 培训学员签到
    TrainApplyUpdate: 68, // 培训学员报名信息修改
    TrainDelete: 70, //培训删除
    TrainCityDelete:69,//策划师培训详情删除
    TrainUserQuery:1061, //策划师培训学员查询1058
    TrainUserSignQuery:1057,// 培训学员签到查询1057
    TrainSignQueryAll: 1059,// 全部签到学员查询1059
    PublishDelete: 73,//赛事删除
    UserAuth: 72,//用户权限设置
    CountDownSet: 53, // 倒计时时间设置
    SetColorImage: 167,//倒计时图片设置
    TimerQuery: 1052, //倒计时查询
    ScoreDeleteRound: 74, //赛事成绩删除
    playerNoExchange: 75, //选手座位对调
    ArrangeRandom: 76, //随机编排
    ScoreNotice: 77, //成绩公示刷新
    SingelGameOver: 78, //单人赛弃权得分    
    AllScoreQuery: 79,// 裁判查询成绩单
    SingelGameOver2: 1063, //单人赛弃权得分
    DeleteAllScore: 80, //清除全部成绩
    UpdateScore: 81, // 修改前轮的成绩
    GamePubAudit: 82, // 赛事预览审核
    PubPreview: 1064, // 赛事预览   
    SetLevelGrade: 83, // 荣誉分设置
    PublishAllCode: 84, //全部赛事列表筛选
    SetGradeQuery: 1065, //积分分配明细查询
    ScoreQueryNew: 1068, //本轮赛事成绩查询
    // 管理员-推荐人支付查询
    AdminIntroPayment: 90, 
    UpdateMatchInfo: 93,//同步比赛信息
    UpdateMemberInfo: 94, //同步会员信息
    // 赛事广告设置
    PublishSettingAdvert: 95,
    PublishAdvertQuery: 1069, //赛事广告查询
    PubArrangeSetAll: 97,//一键赛事编排对阵
    SearchAssociation: 1070,//模糊查询协会
    SendSystemMemberInfo : 1071,//同步系统人员信息,返佣
    TableHeaderCode: 1073,
    GradeLog: 1075, // 积分日志查询
    GroupRankCode: 1076,//团体排名
    ClubAllMemberAudit: 1077,//查询协会下所有会员并审核
    // 策划师证书
    traineeStandard: 101, // 学员是否合格
    traineeQuery: 102,// 学员证书查询
    traineeSetting: 103,// 学员证书设置
    certificateQuery: 1078,// 公共学员证书查询

    // 商城 商品管理相关接口
    ADDGoods: 112,//新增商品
    GoodsQuery: 113,//商品查询
    UpdateShelf: 114,//上架商品修改
    UpDownShelf: 115,//下架商品
    DeleteGoods: 116,//删除商品
    ProductSearch: 1082,//商品搜索

    GoodsSpec: 117,//商品规格查询
    GoodsAddSpec: 118,//商品规格添加
    GoodsUpdateSpec: 119,//商品规格更新
    GooodsRemoveSpec: 120,//商品规格删除

    OrderQuery: 132,//订单查询
    LogisticsQuery: 134, //物流查询
    DeliveryGoods: 135,// 发货 填写物流单号
    RefundPayAduit: 138, //退货退款审核
    RefundGoodsQuery: 144, // 退货收货

    GenerateLgsNumber: 146,//生成运单号 C端寄件下单
    LogisticsQueryNew: 148,//快递100物流查询
    LogisticsCancel: 149,//取消寄件
    // 地址管理
    AddressQuery: 121, //查询收货地址
    AddAddress: 122, //新增收货地址
    UpdateAddress: 123,//修改地址
    RemoveAddress: 124,//删除地址
    // 掼蛋队式赛
    TeamApply: 177,//选手报名
    TeamArrangeAll: 178,//编排
    RoundCards: 179,//本轮级牌设置
    RoundCardsQuery: 180,//本轮级牌查询
    RoundCardsView: 1099,//本轮级牌查询
    SelectCards: 1100, //本局级牌选择
    TeamScoreSub: 182,//队式赛 裁判设置成绩
    TeamSettingCode: 184,//主客队设置
    TeamnameExchange: 185,//队式赛队伍换桌
    EventQuitQuery: 183,//退赛选手查询
    
}


// WEBPACK FOOTER //
// ./src/service/code.js